var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_EASYPOST_BASE } from "@smp/utils";
import { apiRequest, setOrganizationId } from "../../lib";
export class ApiEpConfig {
}
_a = ApiEpConfig;
ApiEpConfig.retrieve = () => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: `${REACT_APP__URL_EASYPOST_BASE}api/v1/config`,
        method: "GET",
    }).catch((e) => {
        if (e instanceof Error &&
            e.message === "API__ROOT__ORGANIZATION_NOT_FOUND") {
            const ep = JSON.parse((typeof localStorage !== "undefined" && localStorage.getItem("ep")) ||
                "{}");
            ep.organization_id = null;
            setOrganizationId(null);
            localStorage.setItem("ep", JSON.stringify(ep));
            return _a.retrieve();
        }
        throw e;
    });
});
//# sourceMappingURL=config.js.map